export const targetingSites = {
  uk: `heycar UK`,
  fr: `heycar FR`,
  de: `heycar DE`,

  rac: `RAC Cars`,
};
